// extracted by mini-css-extract-plugin
module.exports = {"label":"TitledLabel_label__ychgG"};